import type React from 'react';
import { twMerge } from 'tailwind-merge';

type SkeletonProps = React.HTMLAttributes<HTMLSpanElement> & {
  loading?: boolean;
};

export function Skeleton({
  children,
  className,
  loading,

  ...props
}: React.PropsWithChildren<SkeletonProps>) {
  if (!loading) return <>{children}</>;

  return (
    <span
      className={twMerge(['h-5 w-20 bg-gray-200 animate-pulse rounded text-transparent', 'empty:block empty:h-5', className])}
      {...props}
    >
      {children}
    </span>
  );
}
